import { z } from 'zod';
export const AiCapabilityStatusSchema = z.strictObject({
    enabled: z.boolean(),
    providerConfigured: z.boolean(),
    policyNotice: z.string(),
});
